






























import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import Label from "@/components/Label.vue";


@Component({
    components: {
        Label
    }
})
export default class Counter extends Vue {
    // Member:

    // Properties:
    @Prop({required: true})
    public count!: number;

    @Prop({required: true})
    public titleSingular!: string;

    @Prop({required: true})
    public titlePlural!: string;

    @Prop({required: false})
    public criticalNumber?: number;

    // Getter:

    // Component Lifecycle Methods:

    // Methods:
}
